import { Row, Col, Card } from "react-bootstrap";

interface TeamSummaryProps {
    totalUsers: number;
    activeUsers: number;
    activityPercentage: number;
    directUsers: number;
}

const TeamSummary = ({
    totalUsers,
    activeUsers,
    activityPercentage,
    directUsers
}: TeamSummaryProps) => {
    return (
        <>
            <h5 className="text-white fw-bold mb-3">
                Resumen de mi red
            </h5>

            <Row className="g-3 mb-4">

                <Col md={3}>
                    <Card className="border-0 rounded-4 p-3 bg-dark">
                        <div className="d-flex align-items-center gap-3">
                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                    width: 60,
                                    height: 60,
                                    background: "rgba(59,130,246,.15)"
                                }}
                            >
                                <i
                                    className="ri-team-fill"
                                    style={{
                                        color: "#3B82F6",
                                        fontSize: 30
                                    }}
                                />
                            </div>

                            <div>
                                <small className="text-secondary">
                                    Afiliados Registrados
                                </small>

                                <h2
                                    className="fw-bold mb-0"
                                    style={{ color: "#3B82F6" }}
                                >
                                    {totalUsers.toLocaleString()}
                                </h2>

                                <small className="text-secondary">
                                    Total en toda tu red
                                </small>
                            </div>
                        </div>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="border-0 rounded-4 p-3 bg-dark">
                        <div className="d-flex align-items-center gap-3">

                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                    width: 60,
                                    height: 60,
                                    background: "rgba(34,197,94,.15)"
                                }}
                            >
                                <i
                                    className="ri-user-follow-fill"
                                    style={{
                                        color: "#22C55E",
                                        fontSize: 30
                                    }}
                                />
                            </div>

                            <div>
                                <small className="text-secondary">
                                    Afiliados Activos
                                </small>

                                <h2
                                    className="fw-bold mb-0"
                                    style={{ color: "#22C55E" }}
                                >
                                    {activeUsers.toLocaleString()}
                                </h2>

                                <small className="text-secondary">
                                    Usuarios con actividad
                                </small>
                            </div>

                        </div>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="border-0 rounded-4 p-3 bg-dark">
                        <div className="d-flex align-items-center gap-3">

                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                    width: 60,
                                    height: 60,
                                    background: "rgba(245,158,11,.15)"
                                }}
                            >
                                <i
                                    className="ri-bar-chart-box-fill"
                                    style={{
                                        color: "#F59E0B",
                                        fontSize: 30
                                    }}
                                />
                            </div>

                            <div>
                                <small className="text-secondary">
                                    Actividad de la Red
                                </small>

                                <h2
                                    className="fw-bold mb-0"
                                    style={{ color: "#F59E0B" }}
                                >
                                    {activityPercentage}%
                                </h2>

                                <small className="text-secondary">
                                    Sobre el total registrado
                                </small>
                            </div>

                        </div>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="border-0 rounded-4 p-3 bg-dark">
                        <div className="d-flex align-items-center gap-3">

                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                    width: 60,
                                    height: 60,
                                    background: "rgba(168,85,247,.15)"
                                }}
                            >
                                <i
                                    className="ri-group-fill"
                                    style={{
                                        color: "#A855F7",
                                        fontSize: 30
                                    }}
                                />
                            </div>

                            <div>
                                <small className="text-secondary">
                                    Directos (Nivel 1)
                                </small>

                                <h2
                                    className="fw-bold mb-0"
                                    style={{ color: "#A855F7" }}
                                >
                                    {directUsers}
                                </h2>

                                <small className="text-secondary">
                                    Usuarios directos
                                </small>
                            </div>

                        </div>
                    </Card>
                </Col>

            </Row>
        </>
    );
};

export default TeamSummary;